// extracted by mini-css-extract-plugin
export var activeFilterButton = "_qs-c";
export var backButton = "_qs-4";
export var backIcon = "_qs-5";
export var chevronShortcut = "_qs-6";
export var container = "_qs-1";
export var editor = "_qs-8";
export var editorWrapper = "_qs-7";
export var prefix = "_qs-2";
export var searchIcon = "_qs-3";
export var suffix = "_qs-9";
export var suffixContent = "_qs-a";
export var suffixText = "_qs-b";
export var wrapper = "_qs-0";